let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cbkj0")).then(() => parcelRequire('j8AG8'));